<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Configurazioni', route: '/backoffice/configurazioni' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Configurazioni</h1>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Elenco configurazioni</h2>
        </div>
        <a class="acc-btn acc-btn-primary" routerLink="/backoffice/configurazioni/add">
            <i class="bi bi-plus"></i>
            Aggiungi configurazione
        </a>
    </div>

    <p-table #dt
        [loading]="loading"
        [value]="configurazioni"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['descrizione', 'value']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} configurazioni"
        [rows]="5"
        [rowsPerPageOptions]="[5, 10, 20, 50]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full">
                <div class="w-full">
                    <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                        <p-inputicon styleClass="bi bi-search" />
                        <input type="text" pInputText (input)="onGlobalFilter(dt, $event)" placeholder="Cerca configurazione…" [style]="{'width': '100%'}" />
                    </p-iconfield>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="descrizione" class="w-2/4">Descrizione <span class="inline-flex"><p-sortIcon field="descrizione" /></span></th>
                <th pSortableColumn="value" class="w-1/4">Valore <span class="inline-flex"><p-sortIcon field="value" /></span></th>
                <th class="w-1/4 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-configurazione>
            <tr>
                <td>
                    <span class="p-column-title">Descrizione</span>
                    <span class="cell-nome">{{configurazione.descrizione}}</span>
                </td>
                <td>
                    <span class="p-column-title">Valore</span>
                    {{configurazione.value}}
                </td>
                <td class="text-center">
                    <span class="p-column-title">Azioni</span>
                    <div class="table-actions">
                        <i class="bi bi-pencil" [routerLink]="'/backoffice/configurazioni/' + configurazione.id"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteConfigurazione>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeleteConfigurazione()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteConfigurazione()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeleteConfigurazione($event, configurazione)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessuna configurazione trovata.</td>
            </tr>
        </ng-template>
    </p-table>
</section>
